import React from 'react';
import { Alert } from 'react-bootstrap';

interface ChatHeaderProps {
  isClosed: boolean;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ isClosed }) => {
  if (!isClosed) return null;
  
  return (
    <Alert variant="warning" className="mb-3">
      This conversation is closed. Create a new conversation to send message.
    </Alert>
  );
};


